/*
	impements api for remote logging
	- send the frontend log messages to the backend
	- catch web client's unhandled JS errors and send to the server feed for debugging

	elog: print logging message to console and send it to remote server feed
	esend: internal function - send to remote server feed
	if window.elog_debug isn't set to true, debug messages won't be sent to the server
	(c) starshiptroopers.dev
 */

let clientConxtextID = "";

function setClientContextID(id) {
	if (clientConxtextID === "")
		clientConxtextID  = id;
}
function elog(severity, msg, obj) { //remote log message
	if (msg === null) {
		msg = severity
		severity = "INFO"
	}

	if (! obj && severity === "ERROR") {
		obj = new Error("StackLog")
	}

	if (obj instanceof Error) {
		obj = {
			name: obj.name,
			message: obj.message,
			stack: obj.stack,
		}
	}

	let message = {
		msg: msg,
		url: window.document.location.href,
		useragent: navigator.userAgent,
		object: obj?JSON.stringify(obj):"",
		severity: severity
	};

	// don't sent debug messages to remote logging server if elog_debug is false

	if (! window.maphub_elog_debug && severity === "DEBUG") {
		console.debug(JSON.stringify(message));
		return
	}

	esend(message);
}

function log(severity, msg, obj) {
	let consoleLog = console.info;
	if (typeof console[severity.toLowerCase()] === "function") {
		consoleLog = console[severity.toLowerCase()];
	}
	if (msg === undefined) {
		msg = severity;
		severity = "INFO";
	}

	if (obj !== undefined) {
		consoleLog(`${severity}: ${msg}`, obj);
	} else {
		consoleLog(`${severity}: ${msg}`);
	}
}

// profiling logs message with timestamp and some profiling data
function profiling(label, msg) {
	if (! window.maphub_profiling)
		return
	console.timeLog(label, msg)
}

// profilingStart start profiling timer with label name
function profilingStart(label) {
	if (! window.maphub_profiling)
		return
	console.time(label)
}

// profilingFinish finishes profiling timer with label name and write the time with message
function profilingFinish(label) {
	if (! window.maphub_profiling)
		return
	console.timeEnd(label)
}

function esend(params) { //send message

	let consoleLog = console.info;
	if (typeof console[params.severity.toLowerCase()] === "function") {
		consoleLog = console[params.severity.toLowerCase()];
	}

	let catcher_server_url = '/logFeed/push';
	let xhr = new XMLHttpRequest();
	xhr.open('POST', catcher_server_url, true);
	xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	xhr.setRequestHeader("x-mapper-client-context-id", clientConxtextID);

	let data = JSON.stringify(params);
	xhr.send(data);

	if (params.severity !== "DEBUG" && params.object) {
		consoleLog(`${params.severity}: ${params.msg}`, params.object);
	} else {
		consoleLog(`${params.severity}: ${params.msg}`);
	}

	return true;
}

function caller(level) {
	const fnNameMatcher = /([^(]+)@|at ([^(]+) \(/;
	let fnName = function(str) {
		const regexResult = fnNameMatcher.exec(str);
		return regexResult[1] || regexResult[2];
	}

	if (!level) {
		level = 1;
	}

	let callerName;
	try {
		const logLines = (new Error().stack).split('\n');
		callerName = fnName(logLines[level]);

		if (callerName === 'caller') {
			callerName = fnName(logLines[level+1]);
		}

		if (callerName === 'elog' || callerName === 'profiling' || callerName === 'log') {
			callerName = fnName(logLines[level+2]);
		}
	} catch {

	}

	return callerName;
}

window.onerror = function(msg, url, line, column, error) {

	let string = msg.toLowerCase();
	let message = msg;
    if (string.indexOf("script error") > -1){
		message = 'Script Error: no details';
    }

	esend({ msg: message,
            url: url,
            line: line,
			useragent: navigator.userAgent,
            object: (error && error.stack)?error.stack:"",
			severity: 'ERROR'
    });
    return true;
};

//catch unhandled promise errors (rejects)
window.addEventListener('unhandledrejection', event => {
	let error = event.reason; //  Необработанный объект ошибки, как request.error
	esend( {
		msg: error.toString(),
		url: window.document.location.href,
		line: 0,
		useragent: navigator.userAgent,
		object: (error && error.stack)?error.stack:"",
		severity: 'ERROR'
	});
	event.stopPropagation();
});

export {
	clientConxtextID,
	setClientContextID,
	elog,
	log,
	profiling,
	profilingStart,
	profilingFinish,
}
